export const ImportItemStatus = { 1: 'Sucesso', 2: 'Erro', 3: 'Duplicado' };
export const ImportableEntityType = { 'unit': 'Unidade', 'user': 'Usuário', 'access_point': 'Ponto de Acesso', 'group': 'Grupo de Acesso', 'device_event': 'Evento da Controladora' }

export const ImportationHiddenFields = [
	'user__licenceId',
	'user__id_condominium',
	'user__is_active_cpf_constraint',
	'user__is_active_mail_constraint',
	'user__is_active_phone_constraint',
	'user__target_name'
];

export const ImportationRemovedFields = [
	'user__last_operation',
	'user__status',
];

export const ImportationField = {
	'user__cpf': 'CPF',
	'user__rg': 'RG',
	'user__enabled': 'Ativo',
	'user__name': 'Nome',
	'user__mail': 'Email',
	'user__uuid': 'UUID',
	'user__phone_number': 'Telefone',
};

export const DataSourceName = {
	1: 'Módulo Acesso',
	2: 'Web'
}

export const BackupStatus = {
	1: 'Iniciado',
	2: 'Enviado',
	3: 'Importado',
	4: 'Importando',
	5: 'Falha no Envio',
	6: 'Falha na Importação',
}